import http from "../utils/http";

export interface StartRecordingRequest {
  appointmentId: string;
  recordingType?: "audio" | "video";
}

export interface StopRecordingRequest {
  appointmentId: string;
  egressId?: string;
}

export interface RecordingResponse {
  recordingId: string;
  recordingType: string;
  startedAt: string;
  roomName: string;
}

export interface StopRecordingResponse {
  recordingId: string;
  stoppedAt: string;
  fileUrl?: string;
  fileSize?: number;
}

export interface RecordingStatus {
  isRecording: boolean;
  recordingId: string | null;
  startedAt: string | null;
  roomName: string;
}

export interface Participant {
  identity: string;
  name: string;
  joinedAt: string;
  isPublisher: boolean;
  isSubscriber: boolean;
}

export interface ParticipantsResponse {
  participants: Participant[];
}

// Start LiveKit recording
export const startLiveKitRecording = async (
  data: StartRecordingRequest
): Promise<RecordingResponse> => {
  const response = await http.post("/livekit/record/start", data);
  return response.data;
};

// Stop LiveKit recording
export const stopLiveKitRecording = async (
  data: StopRecordingRequest
): Promise<StopRecordingResponse> => {
  const response = await http.post("/livekit/record/stop", data);
  return response.data;
};

// Get recording status
export const getRecordingStatus = async (
  appointmentId: string
): Promise<RecordingStatus> => {
  const response = await http.get(`/livekit/recording/status/${appointmentId}`);
  return response.data;
};

// Get room participants
export const getRoomParticipants = async (
  appointmentId: string
): Promise<ParticipantsResponse> => {
  const response = await http.get(
    `/livekit/room/participants/${appointmentId}`
  );
  return response.data;
};
